import React from 'react';
import { Box, SimpleGrid } from '@chakra-ui/react';
import Container from '../ui/Container';
import SectionHeader from '../ui/SectionHeader';
import BenefitCard from '../ui/BenefitCard';
import { BENEFITS } from '../../data/benefits';

export default function WhyChooseUs() {
  return (
    <Box as="section" py={{ base: 14, md: 20 }} bg="surface.muted">
      <Container>
        <SectionHeader title="¿Por qué elegir SIESA?" />
        <SimpleGrid columns={{ base: 1, sm: 2, lg: 5 }} spacing={5}>
          {BENEFITS.map(benefit => (
            <BenefitCard key={benefit.id} benefit={benefit} />
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
}
